export const latestUpdatesPrepareData = (data: any) => {
  return data.allWpPost?.edges?.map((post: any) => ({
    title: post.node.title,
    uri: post.node.uri,
    image: post.node.featuredImage.node.localFile,
  }));
};
